import React from "react";

const DEFAULT_LINES = [
  "Thinking of You",
  "You’re in my heart and in my thoughts.",
  "Here’s an invitation to experience an extraordinary connection.",
];

const formatExpiry = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "";

// The printable gift card the purchaser gives to their recipient (landscape,
// 11:8.5). `lines` are the three chosen lines (opening, personal message,
// invitation). The code, amount ("worth up to", only if the giver chose to
// show it) and expiry come from the gift itself, never from the wording.
// The QR code (rendered by the backend) opens the redeem page with the code
// already filled in. Nothing about the purchaser appears unless they typed a
// "from" name.
//
// `color` is the chosen background (hex). `plain` prints it on white instead
// (saves ink), and `size="quarter"` is the small copy: same content, typeset
// with its own larger minimum sizes so it stays readable at 5.5 x 4.25 in.
export const DEFAULT_CARD_COLOR = "#D8E7D1";

export default function GiftCard({ code, qrSvg, redeemUrl, worthUpTo, expiresAt, lines, fromName, color, plain, size }) {
  const shown = lines && lines.length ? lines : DEFAULT_LINES;
  const expiry = formatExpiry(expiresAt);
  const redeemAt = redeemUrl ? redeemUrl.split("?")[0].replace(/^https?:\/\//, "") : "verysoul.com";

  return (
    <div
      className={`vs-card ${size === "quarter" ? "vs-card-quarter" : ""} ${plain ? "vs-card-plain" : ""}`}
      style={{ "--vs-card-bg": plain ? "#ffffff" : color || DEFAULT_CARD_COLOR }}
    >
      <div className="vs-card-inner">
        <p className="vs-card-eyebrow">A Gift of Connection</p>
        <h2 className="vs-card-title">{shown[0]}</h2>
        {shown[1] && <p className="vs-card-sentiment">{shown[1]}</p>}
        <div className="vs-card-divider" aria-hidden="true" />
        <p className="vs-card-session">A private mediumship session on Zoom</p>
        {shown[2] && <p className="vs-card-invite">{shown[2]}</p>}
        {fromName && <p className="vs-card-from">With love, {fromName}</p>}

        <div className="vs-card-details">
          <div className="vs-card-detail vs-card-detail-code">
            <span className="vs-card-label">Redemption code</span>
            <span className="vs-card-value vs-card-code">{code}</span>
          </div>
          {worthUpTo && (
            <div className="vs-card-detail">
              <span className="vs-card-label">Max amount</span>
              <span className="vs-card-value">
                {worthUpTo.currency === "USD" ? "$" : worthUpTo.currency + " "}
                {Number(worthUpTo.amount).toFixed(0)}
              </span>
            </div>
          )}
          {expiry && (
            <div className="vs-card-detail">
              <span className="vs-card-label">Expires</span>
              <span className="vs-card-value">{expiry}</span>
            </div>
          )}
          {qrSvg && <img className="vs-card-qr" src={qrSvg} alt="QR code to redeem this gift" />}
        </div>
        <p className="vs-card-redeem">
          To redeem, visit <b>{redeemAt}</b> and enter your code{qrSvg ? ", or scan the QR code" : ""}.
        </p>
      </div>
    </div>
  );
}
